module.exports = __webpack_public_path__ + "static/media/tankTrailer_white.8b0ed04a.svg";